import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    currentStep: Number
  }

  connect() {
    // Listen for turbo frame loads to update progress
    document.addEventListener('turbo:frame-load', this.handleFrameLoad.bind(this))
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.handleFrameLoad.bind(this))
  }

  handleFrameLoad(event) {
    // Only handle invitation_wizard frame
    if (event.target.id !== 'invitation_wizard') return

    // Extract current step from the loaded content
    const stepContent = event.target.querySelector('[data-current-step]')
    if (stepContent) {
      const newStep = parseInt(stepContent.dataset.currentStep)
      if (newStep && newStep !== this.currentStepValue) {
        this.currentStepValue = newStep
        this.updateProgress()
      }
    }
  }

  updateProgress() {
    // Update step circles
    const circles = this.element.querySelectorAll('.wizard-step-label')
    circles.forEach((label, index) => {
      const stepNum = index + 1
      const circle = label.querySelector('.step-circle')

      // Remove all state classes
      label.classList.remove('active', 'completed')
      circle.classList.remove('bg-primary', 'text-white', 'bg-light', 'text-muted')

      if (stepNum < this.currentStepValue) {
        // Completed step
        label.classList.add('completed')
        circle.classList.add('bg-primary', 'text-white')
      } else if (stepNum === this.currentStepValue) {
        // Active step
        label.classList.add('active')
        circle.classList.add('bg-primary', 'text-white')
      } else {
        // Future step
        circle.classList.add('bg-light', 'text-muted')
      }
    })

    // Update connector lines between steps
    const connectors = this.element.querySelectorAll('.wizard-connector')
    connectors.forEach((connector, index) => {
      const stepNum = index + 1

      if (stepNum < this.currentStepValue) {
        connector.classList.add('completed')
      } else {
        connector.classList.remove('completed')
      }
    })

    // Update step titles
    const titles = this.element.querySelectorAll('.step-title')
    titles.forEach((title, index) => {
      const stepNum = index + 1
      title.classList.remove('text-primary', 'fw-bold', 'text-muted')

      if (stepNum === this.currentStepValue) {
        title.classList.add('text-primary', 'fw-bold')
      } else if (stepNum > this.currentStepValue) {
        title.classList.add('text-muted')
      }
    })
  }
}
